/**
 * Mock treatment record data generation functions for testing and development
 */

/**
 * Generate mock treatment records based on customers, practitioners, treatments, and appointments
 * @param {Array} customers
 * @param {Array} practitioners
 * @param {Array} treatments
 * @param {Array} appointments
 * @returns {Array} Array of mock treatment record objects
 */
import { v4 as uuidv4 } from 'uuid';
import { mockAppointments } from './mockAppointments';
import { mockCustomers } from './mockCustomers';
import { mockPractitioners } from './mockPractitioners';
import { mockTreatments } from './mockTreatments';

export const mockTreatmentRecords = [];
export default mockTreatmentRecords; 